import i18n from "i18next";

interface Props {
  shippingMethodCost: string;
  feePerKg: number;
}

export const getShippingCostDisplayText = ({ feePerKg, shippingMethodCost }: Props) => {
  if (feePerKg > 0 && shippingMethodCost === "0") {
    return `${feePerKg}₽`;
  }

  if (shippingMethodCost !== "0" && feePerKg > 0) {
    return `${Number(shippingMethodCost) + feePerKg} ₽`;
  }

  if (shippingMethodCost !== "0") {
    return `${shippingMethodCost} ₽`;
  }

  if (!feePerKg) {
    return i18n.t("Free");
  }
};
